/**
 * Router for Onboarding
 *
 * Flow:
 * 1. Accept Privacy Policy
 * 2. Confirm/Add Personal Contact Information
 * 3. Add additional Contact Information (MVP 2)
 */

import { Navigate } from 'react-router-dom'

import { ActivatingAccountPage } from './pages/activating-account'
import { AdditionalContactInformationPage } from './pages/additional-contact-information/AdditionalContactInformationPage'
import { OnboardingRootPage } from './pages/onboarding-root'
import { PrivacyPolicyPage } from './pages/privacy-policy'

import type { RouteObject } from 'react-router-dom'

const onboardingRoutes: RouteObject[] = [
  {
    path: 'onboarding',
    element: <OnboardingRootPage />,
    children: [
      {
        path: 'privacy-policy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: 'personal-contact-information',
        element: <AdditionalContactInformationPage />,
      },
      {
        path: 'activate-account',
        element: <ActivatingAccountPage />,
      },
      {
        path: '*',
        element: <Navigate to='..' replace />,
      },
    ],
  },
]

export { onboardingRoutes }
